import type React from 'react'
import { cn } from '@/frontend/utils'

export const H1 = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <h1 className={cn('font-bold text-3xl lg:font-extrabold lg:text-5xl', className)}>
      {children}
    </h1>
  )
}
